<template>
  <div>
    <div class="flex-end">
      <Filters />
    </div>
    <h2>
      Number of tracks: <span>{{ tracks.total }}</span>
    </h2>
    <el-table
      :data="tracks.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
      v-loading="loading"
    >
      <el-table-column
        v-if="admin_role"
        label="Artist"
        prop="artist"
        width="230"
        sortable
      ></el-table-column>
      <el-table-column
        label="Track"
        prop="title"
        width="300"
        sortable
      ></el-table-column>
      <el-table-column
        label="Downloads"
        prop="downloads"
        sortable
        :formatter="commaNumTable"
      ></el-table-column>
      <el-table-column
        label="Previews"
        prop="previews"
        sortable
        :formatter="commaNumTable"
      ></el-table-column>
      <el-table-column
        label="Subscribers"
        prop="subscribers"
        sortable
        :formatter="commaNumTable"
      ></el-table-column>
      <el-table-column
        label="Views"
        prop="views"
        sortable
        :formatter="commaNumTable"
      ></el-table-column>
      <el-table-column
        label="No. Videos"
        align="center"
        prop="video"
        sortable
      ></el-table-column>
      <!-- <el-table-column type="expand" label="Videos" width="80%">
        <template slot-scope="props">
          <p v-for="(v, i) in videos" :key="i">
            <a :href="`https://youtube.com/watch?v=${v.video}`" target="_blank">
              {{ `https://youtube.com/watch?v=${v.video}` }}
            </a>
          </p>
        </template>
      </el-table-column> -->
      <el-table-column
        label="No. Channels"
        prop="channel"
        align="center"
        sortable
      ></el-table-column>
      <!-- <el-table-column type="expand" label="Channels" width="90%">
        <template slot-scope="props">
          <p>{{ props.row.channel }}</p>
        </template>
      </el-table-column> -->
      <el-table-column label="Actions" align="right" width="160">
        <template slot-scope="props">
          <el-tooltip content="Show charts" placement="top">
            <el-button
              type="success"
              circle
              size="small"
              icon="el-icon-s-data"
              @click="readTrackChartData(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip class="ml10" content="Show videos and channels">
            <el-popover placement="top" width="400" trigger="click">
              <el-table
                :data="videos"
                class="w100"
                stripe
                v-loading="videos_loading"
              >
                <el-table-column label="Video">
                  <template slot-scope="props">
                    <a
                      :href="
                        `https://youtube.com/watch?v=${props.row.video_id}`
                      "
                      target="_blank"
                    >
                      {{ props.row.title }}
                    </a>
                  </template>
                </el-table-column>
                <el-table-column label="Channel">
                  <template slot-scope="props">
                    <a
                      :href="
                        `https://youtube.com/channel/${props.row.channel_id}`
                      "
                      target="_blank"
                    >
                      {{ props.row.channel_name }}
                    </a>
                  </template>
                </el-table-column>
              </el-table>
              <el-button
                slot="reference"
                type="success"
                circle
                size="small"
                icon="el-icon-video-camera"
                @click="readTrackVideos(props.row.track)"
              ></el-button>
            </el-popover>
          </el-tooltip>
          <el-tooltip class="ml10" content="Export CSV" placement="top">
            <el-button
              type="primary"
              circle
              size="small"
              icon="el-icon-document"
              @click="exportCSV(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="tracks.current_page"
      :page-sizes="[5, 10, 25, 50, 100, 500]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tracks.total"
    ></el-pagination>
    <el-dialog
      :title="track_chart_name"
      :visible.sync="dialogVisibleTrack"
      width="75%"
      top="7vh"
    >
      <el-tabs :tab-position="subTabsPosition">
        <el-col :span="24">
          <el-divider content-position="left">Previews</el-divider>
        </el-col>
        <el-col id="vid" :span="24" :lg="12">
          <GChart
            type="LineChart"
            :data="track_chart_previews"
            :options="LineChartSett"
          />
        </el-col>
        <el-col id="vid" :span="24" :lg="12">
          <GChart
            type="LineChart"
            :data="track_chart_previews_daily"
            :options="LineChartSett"
          />
        </el-col>
        <el-col :span="24">
          <el-divider content-position="left">Downloads</el-divider>
        </el-col>
        <el-col id="vid" :span="24" :lg="12">
          <GChart
            type="LineChart"
            :data="track_chart_downloads"
            :options="LineChartSett"
          />
        </el-col>
        <el-col id="vid" :span="24" :lg="12">
          <GChart
            type="LineChart"
            :data="track_chart_downloads_daily"
            :options="LineChartSett"
          />
        </el-col>
        <el-col :span="24">
          <el-divider content-position="left">Subscribers</el-divider>
        </el-col>
        <el-col id="vid" :span="24" :lg="12">
          <GChart
            type="LineChart"
            :data="track_chart_subscribers"
            :options="LineChartSett"
          />
        </el-col>
        <el-col id="vid" :span="24" :lg="12">
          <GChart
            type="LineChart"
            :data="track_chart_subscribers_daily"
            :options="LineChartSett"
          />
        </el-col>
        <el-col :span="24">
          <el-divider content-position="left">Views</el-divider>
        </el-col>
        <el-col id="vid" :span="24" :lg="12">
          <GChart
            type="LineChart"
            :data="track_chart_views"
            :options="LineChartSett"
          />
        </el-col>
        <el-col id="vid" :span="24" :lg="12">
          <GChart
            type="LineChart"
            :data="track_chart_views_daily"
            :options="LineChartSett"
          />
        </el-col>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { GChart } from 'vue-google-charts'
import Filters from './Filters'

export default {
  components: {
    GChart,
    Filters
  },

  data() {
    return {
      track_chart_name: '',
      dialogVisibleTrack: false,
      subTabsPosition: 'top'
    }
  },

  computed: {
    ...mapState('reportsTracks', [
      'loading',
      'videos_loading',
      'tracks',
      'videos',
      'date_range',
      'page_size',
      'order_column',
      'order_type',
      'LineChartSett'
    ]),

    ...mapGetters('auth', ['admin_role']),
    ...mapGetters('reportsTracks', [
      'track_chart_views',
      'track_chart_views_daily',
      'track_chart_previews',
      'track_chart_previews_daily',
      'track_chart_downloads',
      'track_chart_downloads_daily',
      'track_chart_subscribers',
      'track_chart_subscribers_daily'
    ]),

    color() {
      return '#' + Math.floor(Math.random() * 16777215).toString(16)
    }
  },

  methods: {
    ...mapMutations('reportsTracks', [
      'setPage',
      'setPageSize',
      'setOrdering',
      'setDateRange'
    ]),
    ...mapActions('reportsTracks', [
      'readTracks',
      'readTrackChart',
      'readTrackVideos',
      'exportCSV'
    ]),

    readTrackChartData(data) {
      this.dialogVisibleTrack = true
      this.track_chart_name = `${data.artist} - ${data.title}`
      this.readTrackChart({
        id: data.track,
        start: this.date_range[0],
        end: this.date_range[1]
      })
    },

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readTracks()
    },

    currentChange(page) {
      this.setPage(page)
      this.readTracks()
    },

    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readTracks()
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}

h2 {
  color: #3e3e3e;
  font-size: 1.6rem;
  text-align: left;
  font-weight: 100;
  margin: 1.2rem 0.5rem 2rem;
}

span {
  font-weight: 700;
}
</style>
